module.exports = __webpack_public_path__ + "img/Prix_Choc.4f7461bd.png";